import { getLoginSessionId, login } from '@/api/newApi/home';
import { message } from 'antd';

// 声明全局 captchaLoadJS 函数类型
declare global {
  function captchaLoadJS(option: any, callback: (obj: any) => void): void;
}

// 定义接口类型
interface SessionResponse {
  sessionId?: string;
  value?: string;  // 添加 value 属性
  data?: {
    sessionId?: string;
  };
}

// 定义登录结果类型
interface LoginResult {
  success?: boolean;
  [key: string]: any;
}

export const getLoginVt = async () => {
  const res = await getLoginSessionId({});
  if (res?.success) {
    return res?.value;
  } else {
    message.error(res?.msg);
    return '';
  }
};

export const loginVt = async (params: any) => {
  const res = await login(params);
  if (res?.success) {
    return res;
  } else {
    message.error(res?.msg);
    return '';
  }
};

// 语言 1-中文简体2-中文繁体3-英文4-泰文5-俄文 6-西班牙语  7-印尼语 8-韩语 9-日语 10-荷兰语  
const langCodeMap = {
  "zh": 1,
  "en": 3,
  "vi": 3,
  "hu": 3,
  "pt-BR": 3,
  "th": 4,
  "zh_Hant": 2,
  "id": 7,
  "ms": 3,
  "ru": 5
}
/**
 * 登录验证滑块方法
 * @param username 账户名
 * @param password 密码
 * @returns Promise<any>
 */
export const loginWithSliderCaptcha = async (username: string, password: string, langCode: string): Promise<any> => {
  // 先调用getLoginVt获取session
  const sessionRes = await getLoginVt() as SessionResponse;
  const sessionId = sessionRes
  
  if (!sessionId) {
    throw new Error('获取session失败');
  }

  return new Promise((resolve, reject) => {
    try {
      // 初始化验证码对象
      let Jcap: any = {};
      
      const option = {
        sessionId: sessionId, // 会话id                
        language: langCodeMap[langCode as keyof typeof langCodeMap] || 3,
        onSuccess: async function(ret: any) {
          try {
            // 验证成功后回调（ret.vt为后台需要再次验证的vt）
            const loginParams = {
              userName: username,
              password: password,
              sessionId: sessionId,
              vt: ret.vt
            };
            
            console.log('loginParams', loginParams)
            // 调用登录接口
            const loginResult = await loginVt(loginParams) as LoginResult;
            if (loginResult?.success) {
              location.href='/'
            }
            resolve(loginResult);
          } catch (error) {
            reject(error);
          }
        },
        onLoad: function(data: any) {
          // 验证码初始化完毕时会被调用
          console.log('验证码加载完成:', data);
        },
        onFailure: function(ret: any) {
          // sid失效，vt过期需重新申请sid，调用reset方法
          // 验证失败后回调（接口异常）
          console.error('验证失败:', ret);
          reject(new Error('验证码验证失败'));
        },
        onCancel: function() {
          // console.log('验证码已取消');
          reject(new Error('用户取消验证'));
        },
      };
      
      // 初始化验证码，此函数只需初始化一次，重新创建请调用Jcap.create()
      // 这一步必须这样使用，不能把Jcap.create()移出作用域
      if (typeof captchaLoadJS === 'function') {
        captchaLoadJS(option, function(obj: any) {
          Jcap = obj;
          // 需要创建验证码时调用，显示验证码
          // captchaLoadJS执行后，可通过create创建验证码
          Jcap.create({
            sessionId: sessionId, 
            account: username, 
            ccode: 86
          }); 
        });
      } else {
        reject(new Error('captchaLoadJS函数未找到，请确保已正确引入验证码SDK'));
      }
      
    } catch (error) {
      reject(error);
    }
  });
};